import _classCallCheck from "/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
export var Info =
/**
 * @constructor
 * @param {string} property
 * @param {string} attribute
 */
function Info(property, attribute) {
  _classCallCheck(this, Info);

  /** @type {string} */
  this.property = property;
  /** @type {string} */

  this.attribute = attribute;
};
/** @type {string|null} */

Info.prototype.space = null;
Info.prototype.boolean = false;
Info.prototype.booleanish = false;
Info.prototype.overloadedBoolean = false;
Info.prototype.number = false;
Info.prototype.commaSeparated = false;
Info.prototype.spaceSeparated = false;
Info.prototype.commaOrSpaceSeparated = false;
Info.prototype.mustUseProperty = false;
Info.prototype.defined = false;